import CXMApiClient from "../../CXMApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";
function initialState() {
  return {
    AddFinancialInfoModal: {
      ShowModal: false,
      EntityId: null,
      VehicleFinancials: null,
      ShowSelectFieldModal: false,
      inputType: null,
    },
  };
}

const state = initialState();

const getters = {
  AddFinancialInfoModal: function(state) {
    return state.AddFinancialInfoModal;
  },
};

const actions = {
  getDealsheetConvertInfo(context, payload) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/Dealsheet/entity/${payload.entityId}/getConvertInfo`, payload, scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful && resp.data.data)
            resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  postDealsheetConvertInfo(context, payload) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/Dealsheet/entity/${payload.entityID}/postConvertInfo`, payload, scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful && resp.data.data)
            resolve(resp.data.data);
          else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  openSelectFieldModal(context, data) {
    context.commit("openSelectFieldModal", data);
  },
  closeSelectFieldModal(context) {
    context.commit("closeSelectFieldModal");
  },
  openAddFinancialInfoModal(context, data) {
    context.commit("openAddFinancialInfoModal", data);
  },
  closeAddFinancialInfoModal(context) {
    context.commit("closeAddFinancialInfoModal");
  },
};

const mutations = {
  openSelectFieldModal(state, data) {
    state.AddFinancialInfoModal.ShowSelectFieldModal = true;
    state.AddFinancialInfoModal.inputType = data.inputType;
  },
  closeSelectFieldModal(state) {
    state.AddFinancialInfoModal.ShowSelectFieldModal = false;
    state.AddFinancialInfoModal.inputType = null;
  },
  openAddFinancialInfoModal(state, data) {
    state.AddFinancialInfoModal.ShowModal = true;
    state.AddFinancialInfoModal.EntityId = data.entityId;
    state.AddFinancialInfoModal.VehicleFinancials = data.vehicleFinancials;
  },
  closeAddFinancialInfoModal(state) {
    state.AddFinancialInfoModal.ShowModal = false;
    state.AddFinancialInfoModal.EntityId = null;
    state.AddFinancialInfoModal.VehicleFinancials = null;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/FinancialInfo.js